<template>
  <div class="gx-detail">
    <gx-loading :show="pageLoading" text="加载中..." />
    <!-- 头部 -->
    <div v-if="!embedded" class="gx-detail__head">
      <button class="gx-detail__back" @click="$router.back()">〈 返回列表</button>
      <span class="gx-detail__head-title">售后详情</span>
    </div>

    <div v-if="loadError" class="gx-detail__error">
      <p>{{ loadError }}</p>
      <button class="gx-detail__btn gx-detail__btn--primary" @click="$router.push('/new_aftersales_workbench')">返回列表</button>
    </div>

    <div v-else-if="aftersale" class="gx-detail__layout">
      <!-- 左主栏 -->
      <div class="gx-detail__main">
        <!-- 处理进度 -->
        <div class="gx-detail__card">
          <div class="gx-detail__card-title">
            <span class="gx-detail__card-title-bar"></span>
            处理进度
          </div>
          <div class="gx-detail__steps">
            <div v-for="(item, idx) in processStepBarList" :key="item.key" class="gx-detail__step" :class="'gx-detail__step--' + item.uiState">
              <span v-if="idx > 0" class="gx-detail__step-line" :class="{'gx-detail__step-line--red': item.uiState !== 'wait'}"></span>
              <div class="gx-detail__step-node">
                <span class="gx-detail__step-icon">
                  <svg v-if="item.uiState === 'error'" width="11" height="11" viewBox="0 0 10 10" fill="none"><path d="M2 2l6 6M8 2L2 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" /></svg>
                  <span v-else>{{ idx + 1 }}</span>
                </span>
                <span class="gx-detail__step-title">{{ item.title }}</span>
              </div>
            </div>
          </div>

            <div v-if="countdownText || operateList.length || showExtendReceiptStub || showLogisticsInterceptUi" class="gx-detail__actions">
              <span v-if="countdownText" class="gx-detail__countdown">请在 <span class="gx-detail__countdown-num">{{ countdownText }}</span> 内处理，超时未处理将自动同意退款</span>
              <button
                v-for="op in operateList"
                :key="op.val"
                class="gx-detail__btn gx-detail__btn--sm"
                :class="{ 'gx-detail__btn--primary': primaryOperateVals.includes(op.val) }"
                @click="openOperate(op)"
            >{{ op.text }}</button>
            <button v-if="showExtendReceiptStub" class="gx-detail__btn gx-detail__btn--sm" :disabled="extendReceiptSubmitting" @click="confirmExtendReceipt">{{ extendReceiptSubmitting ? '申请中...' : '延长收货' }}</button>
            <template v-if="showLogisticsInterceptUi">
              <button v-if="logisticsInterceptStateNum === 0" class="gx-detail__btn gx-detail__btn--sm" :disabled="logisticsInterceptSubmitting" @click="confirmApplyLogisticsIntercept">{{ logisticsInterceptSubmitting ? '申请中...' : '申请物流拦截' }}</button>
              <span v-else class="gx-detail__tag" :class="'gx-detail__tag--' + logisticsInterceptTagType">{{ logisticsInterceptStatusText }}</span>
            </template>
          </div>
        </div>

        <!-- 售后信息 -->
        <div class="gx-detail__card">
          <div class="gx-detail__card-title">
            <span class="gx-detail__card-title-bar"></span>
            售后信息
            <span class="gx-detail__tag gx-detail__tag--type">{{ typeTagText }}</span>
          </div>
          <div class="gx-detail__grid">
            <div class="gx-detail__row">
              <span class="gx-detail__label">售后类型</span>
              <span class="gx-detail__val">{{ typeTagText }}</span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">订单编号</span>
              <span class="gx-detail__val">
                <a :href="'https://fxg.jinritemai.com/ffa/morder/order/detail?id=' + shopOrderId" target="_blank" rel="noopener noreferrer" class="gx-detail__link">{{ shopOrderId }}</a>
                <i class="gx-detail__copy" @click="copyText(shopOrderId)">⧉</i>
              </span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">下单时间</span>
              <span class="gx-detail__val">{{ orderCreateTime || '-' }}</span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">售后编号</span>
              <span class="gx-detail__val">
                <a :href="'https://fxg.jinritemai.com/ffa/maftersale/aftersale/detail-v3?aftersale_id=' + aftersale.aftersale_id" target="_blank" rel="noopener noreferrer" class="gx-detail__link">{{ aftersale.aftersale_id }}</a>
                <i class="gx-detail__copy" @click="copyText(String(aftersale.aftersale_id))">⧉</i>
              </span>
            </div>
            <div  class="gx-detail__row">
              <span class="gx-detail__label">1688售后编号</span>
              <span class="gx-detail__val">
                <template v-if="showAlibabaOrderRefundInfo">
                  <a :href="'https://dispute.1688.com/refund/assureRefundDetail.htm?refundId=' + alibabaOrderRefundId" target="_blank" rel="noopener noreferrer" class="gx-detail__link">{{ alibabaOrderRefundId }}</a>
                  <i class="gx-detail__copy" @click="copyText(String(alibabaOrderRefundId))">⧉</i>
                </template>
                <template v-else>—</template>
              </span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">1688售后状态</span>
              <span class="gx-detail__val">{{ alibabaOrderRefundStatusText || '—' }}</span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">申请时间</span>
              <span class="gx-detail__val">{{ applyTimeText }}</span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">申请金额</span>
              <span class="gx-detail__val">{{ formatYuan(aftersale.refund_amount) }}</span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">消费者应退款</span>
              <span class="gx-detail__val gx-detail__val--money">{{ consumerRefundText }}</span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">收货状态</span>
              <span class="gx-detail__val">{{ receiptStatusText }}</span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">申请件数</span>
              <span class="gx-detail__val">{{ aftersale.aftersale_num != null ? aftersale.aftersale_num + ' 件' : '-' }}</span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">发货状态</span>
              <span class="gx-detail__val">{{ shipStatusText }}</span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">消费者寄回数量</span>
              <span class="gx-detail__val">{{ returnNumText }}</span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">售后原因</span>
              <span class="gx-detail__val">{{ reasonText }}</span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">订单备注</span>
              <div class="gx-detail__val">
                 <i v-if="orderSellerRemarkFlagShow" class="el-icon-s-flag" :style="{ color: orderSellerRemarkFlagColor,'margin-right':'6px' }"></i>
                <span class="gx-detail__val">{{ orderDetailSellerWordsDisplay }}</span>
                <i class="el-icon-edit-outline gx-detail__copy" @click="openRemarkDialog('order')" v-if="orderIdForRemarkDialog"></i>
              </div>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">售后备注</span>
              <div class="gx-detail__val">
                <span class="">{{ buyerRemark || '—' }}</span>
                <i class="el-icon-edit-outline gx-detail__copy" @click="openRemarkDialog('aftersale')" ></i>
              </div>
            </div>

            <div v-if="aftersale.aftersale_type == 3" class="gx-detail__row">
              <p><span class="gx-detail__label">换货规格</span>{{ aftersale.exchange_sku_info.spec_desc }} x {{ aftersale.exchange_sku_info.num }}</p>
            </div>
          </div>
        </div>

        <!-- 物流信息 -->
        <div class="gx-detail__card">
          <div class="gx-detail__card-hd">
            <div class="gx-detail__card-title">
              <span class="gx-detail__card-title-bar"></span>
              物流信息
            </div>
            <div class="gx-detail__card-tabs">
              <button class="gx-detail__tab" :class="{ 'gx-detail__tab--on': logisticsTab === 'order' }" @click="logisticsTab = 'order'">订单物流</button>
              <button v-if="aftersale.aftersale_type == 0 || aftersale.aftersale_type == 3" class="gx-detail__tab" :class="{ 'gx-detail__tab--on': logisticsTab === 'return' }" @click="logisticsTab = 'return'">退货物流</button>
              <button v-if="aftersale.aftersale_type == 3" class="gx-detail__tab" :class="{ 'gx-detail__tab--on': logisticsTab === 'exchange' }" @click="logisticsTab = 'exchange'">换货物流</button>
            </div>
          </div>
          <div v-if="logisticsTab === 'order'" class="gx-detail__log-block">
            <div class="gx-detail__row">
              <span class="gx-detail__label">快递公司</span>
              <span class="gx-detail__val">{{ orderLogistics.company }}</span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">物流单号</span>
              <span class="gx-detail__val">
                {{ orderLogistics.no || '-'}}
                <i class="gx-detail__copy" @click="copyText(orderLogistics.no)" v-if="orderLogistics.no && orderLogistics.no !== '-'">⧉</i>
              </span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">发货时间</span>
              <span class="gx-detail__val">{{ orderLogistics.time }}</span>
            </div>
          </div>
          <div v-else-if="logisticsTab === 'return'" class="gx-detail__log-block">
            <div class="gx-detail__row"><span class="gx-detail__label">物流公司</span><span class="gx-detail__val">{{ returnLogistics.company }}</span></div>
            <div class="gx-detail__row"><span class="gx-detail__label">物流单号</span>
              <span class="gx-detail__val">
              {{ returnLogistics.no || '-'}}
              <i class="gx-detail__copy" @click="copyText(returnLogistics.no)" v-if="returnLogistics.no && returnLogistics.no !== '-'">⧉</i>
              </span>
            </div>
            <div class="gx-detail__row"><span class="gx-detail__label">寄回时间</span><span class="gx-detail__val">{{ returnLogistics.time }}</span></div>
            <div class="gx-detail__row"><span class="gx-detail__label">售后地址</span>
              <span class="gx-detail__val">{{ returnAddressText}}
                <i class="gx-detail__copy" @click="copyText(returnAddressText)" v-if="returnAddressText && returnAddressText !== '-'">⧉</i>
              </span>
            </div>
          </div>
          <div v-else class="gx-detail__log-block">
            <div class="gx-detail__row"><span class="gx-detail__label">快递公司</span><span class="gx-detail__val">{{ exchangeLogistics.company }}</span></div>
            <div class="gx-detail__row"><span class="gx-detail__label">物流单号</span>
              <span class="gx-detail__val">{{ exchangeLogistics.no || '-'}}
                <i class="gx-detail__copy" @click="copyText(exchangeLogistics.no)" v-if="exchangeLogistics.no && exchangeLogistics.no !== '-'">⧉</i>
              </span>
            </div>
            <div class="gx-detail__row"><span class="gx-detail__label">发货时间</span><span class="gx-detail__val">{{ exchangeLogistics.time }}</span></div>
          </div>
        </div>

        <!-- 1688商品信息 -->
        <div class="gx-detail__card">
          <div class="gx-detail__card-title">
            <span class="gx-detail__card-title-bar gx-detail__card-title-bar--blue"></span>
            1688商品信息
          </div>
          <div v-if="orderProduct">
            <div class="gx-detail__product">
              <div class="gx-detail__pic">
                <span class="gx-detail__pic-img">
                  <img v-if="orderProduct.product_pic" :src="orderProduct.product_pic" alt="" />
                  <span v-else>🛍️</span>
                </span>
                <span class="gx-detail__pic-type">抖店图</span>
              </div>
              <template v-if="alibabaProduct">
               <div class="gx-detail__switch">⇄</div>
               <div class="gx-detail__pic">
                <span class="gx-detail__pic-img gx-detail__pic-img--1688">
                   <img v-if="alibabaProduct.img" :src="alibabaProduct.img" alt="" />
                  <span v-else>🛍️</span>
                </span>
                 <span class="gx-detail__pic-type text-blue">1688图</span>
               </div>
             </template>
              <div class="gx-detail__pbody">
                <div class="gx-detail__ptitle">{{ orderProduct.product_name }}</div>
                <div class="gx-detail__p1688title text-blue" v-if="alibabaProduct">↳ {{ alibabaProduct.name || '-' }}</div>
              </div>
            </div>
            <div class="gx-detail__grid">
              <template v-if="orderProduct.product_spec&&typeof orderProduct.product_spec==='string'">
                <div class="gx-detail__row" v-for="(spec,index) in JSON.parse(orderProduct.product_spec)" :key="index">
                  <span class="gx-detail__label">{{spec.name}}</span>
                  <span class="gx-detail__val">{{spec.value}}</span>
                </div>
              </template>
              <div class="gx-detail__row"><div class="gx-detail__label">数量</div><div class="gx-detail__val">{{ orderProduct.item_num || '-' }}</div></div>
              <div class="gx-detail__row"><div class="gx-detail__label">订单编号</div><div class="gx-detail__val">{{ shopOrderId || '-' }}</div></div>
              <div class="gx-detail__row"><div class="gx-detail__label">商品ID</div><div class="gx-detail__val">{{ orderProduct.goods_id || orderProduct.dd_goods_id || '-' }}</div></div>
              <div class="gx-detail__row"><div class="gx-detail__label">下单时间</div><div class="gx-detail__val">{{ orderCreateTime || '-' }}</div></div>
            </div>
            <div class="gx-detail__product--1688" v-if="alibabaProduct">
              <div class="gx-detail__row" v-if="alibabaProduct.offer_url || alibabaProduct.offer_id">
                <div class="gx-detail__label">1688商品链接：</div>
                <div class="gx-detail__val text-blue">
                  <span class="text-blue is-link" @click="openAlibabaOfferDetail(alibabaProduct)">跳转查看 ↗</span>
                </div>
              </div>
            </div>
            <div class="gx-detail__price">金额明细</div>
            <div class="gx-detail__grid" >
              <div class="gx-detail__row">
                <div class="gx-detail__label">退款金额</div>
                <div class="gx-detail__val gx-detail__val--money" >{{ formatYuan(aftersale.refund_amount) }}</div>
              </div>
              <div class="gx-detail__row">
                <div class="gx-detail__label">实付金额</div>
                <div class="gx-detail__val">{{ userPaidText }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧栏 -->
      <div class="gx-detail__side">
        <!-- 协商记录 -->
        <div class="gx-detail__card">
          <div class="gx-detail__card-title">
            <span class="gx-detail__card-title-bar"></span>
            处理时间线
<!--            <span class="gx-detail__card-count">共 {{ negotiationTotal }} 条</span>-->
          </div>
          <div v-if="timelineRecordsDisplay.length" class="gx-detail__timeline">
            <div v-for="(rec, idx) in timelineRecordsDisplay" :key="'neg-' + idx + '-' + (rec.time || '')" class="gx-detail__tl-item" :class="{
              'gx-detail__tl-item--user': rec.role === 1,
              'gx-detail__tl-item--plain': rec.role !== 1 && !rec.text && !(rec.desc_kvs && rec.desc_kvs.length) && !negotiationEvidenceBlocks(rec).length,
              'gx-detail__tl-item--ok': rec.role !== 1 && /(完成|结束)/.test(rec.action || ''),
              'gx-detail__tl-item--done': rec.role !== 1 && !/(完成|结束)/.test(rec.action || '') && /成功/.test(rec.action || '')
            }">
              <span class="gx-detail__tl-dot"></span>
              <div class="gx-detail__tl-body">
                <div class="gx-detail__tl-action">{{ rec.action || '节点' }}</div>
                <div v-if="rec.time" class="gx-detail__tl-time">{{ rec.time }}</div>
                <div v-if="rec.text" class="gx-detail__tl-text">{{ rec.text }}</div>
                <div v-if="rec.desc_kvs && rec.desc_kvs.length" class="gx-detail__tl-kvs">
                  <p v-for="(kv, ki) in rec.desc_kvs" :key="ki"><em>{{ kv.key }}</em>：{{ kv.value }}</p>
                </div>
                <div v-if="negotiationEvidenceBlocks(rec).length" class="gx-detail__tl-evidence">
                  <p class="gx-detail__tl-evidence-hd">凭证信息</p>
                  <div v-for="(blk, bi) in negotiationEvidenceBlocks(rec)" :key="'ev-' + idx + '-' + bi" class="gx-detail__tl-evidence-block">
                    <p v-if="blk.desc" class="gx-detail__tl-evidence-desc">{{ blk.desc }}</p>
                    <div v-if="blk.urls.length" class="gx-detail__tl-evidence-imgs">
                      <span v-for="(url, ui) in blk.urls" :key="'evu-' + idx + '-' + bi + '-' + ui" class="gx-detail__tl-evidence-thumb">
                        <img :src="url" alt="" @click="previewImg(url)" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="gx-detail__tl-placeholder">
            <p v-for="(t, i) in placeholderTimelineDisplay" :key="i">{{ t }}</p>
          </div>
          <div v-if="negotiationNeedToggle" class="gx-detail__tl-toggle">
            <button class="gx-detail__link" @click="negotiationExpanded = !negotiationExpanded">
              <template v-if="negotiationExpanded">收起 ▲</template>
              <template v-else>展开全部（共 {{ negotiationTotal }} 条） ▼</template>
            </button>
          </div>
        </div>
        <!--1688上家信息-->
        <div class="gx-detail__card" v-if="alibabaAftersale">
          <div class="gx-detail__card-title">
            <span class="gx-detail__card-title-bar gx-detail__card-title-bar--orange"></span>
            1688上家信息
          </div>
          <div class="gx-detail__log-block">
            <div class="gx-detail__row">
              <span class="gx-detail__label">上家旺旺</span>
              <div class="gx-detail__val">
                <span class="gx-detail__link" @click="openAlibabaWangwangChat(alibabaAftersale)" v-if="alibabaAftersale.wangwang_account || alibabaAftersale.wangwang_chat_url">{{ alibabaAftersale.wangwang_account || '-' }}</span>
              </div>
            </div>
          </div>
        </div>
        <!--1688采购单信息-->
        <div class="gx-detail__card" v-if="alibabaAftersale">
          <div class="gx-detail__card-title">
            <span class="gx-detail__card-title-bar gx-detail__card-title-bar--green"></span>
            1688采购单信息
          </div>
          <div class="gx-detail__log-block">
            <div class="gx-detail__row">
              <span class="gx-detail__label">采购单号</span>
              <div class="gx-detail__val">
                <a :href="'https://air.1688.com/app/ctf-page/trade-order-detail/index.html?orderId=' + alibabaAftersale.alibaba_order_id"
                   target="_blank" class="gx-detail__link">
                  {{ alibabaAftersale.alibaba_order_id }}
                </a>
                <i class="gx-detail__copy" @click="copyText(String(alibabaAftersale.alibaba_order_id))" >⧉</i>
              </div>
            </div>
          </div>
        </div>
        <!-- 1688售后信息-->
<!--        <div class="gx-detail__card" v-if="alibabaAftersale">
          <div class="gx-detail__card-title">
            <span class="gx-detail__card-title-bar gx-detail__card-title-bar&#45;&#45;green"></span>
            1688售后信息
          </div>
          <div class="gx-detail__product" v-if="alibabaProduct">
            <div class="gx-detail__pimg" :class="{ 'is-link': alibabaProduct.offer_url || alibabaProduct.offer_id }"
                 @click="openAlibabaOfferDetail(alibabaProduct)" >
              <img v-if="alibabaProduct.img" :src="alibabaProduct.img" alt="" />
              <div v-else class="is-empty" style="width:100%;height:100%"></div>
            </div>
            <div class="gx-detail__pbody">
              <p class="gx-detail__ptitle" :class="{ 'is-link': alibabaProduct.offer_url || alibabaProduct.offer_id }"
                 @click="openAlibabaOfferDetail(alibabaProduct)"
              >{{ alibabaProduct.name || '-' }}</p>
              <p class="gx-detail__pspec">{{ alibabaProduct.sku_spec_value || '-' }}</p>
              <p class="gx-detail__pmeta" v-if="alibabaProduct.offer_id">商品ID：{{ alibabaProduct.offer_id }}</p>
            </div>
          </div>
          <div class="gx-detail__log-block gx-detail__ops">
            <div class="gx-detail__row"><span class="gx-detail__label">售后状态</span>{{ alibabaAftersale.refund_status_text || '-' }}</div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">售后金额</span>
              <div class="gx-detail__val">
                <span class="gx-detail__val&#45;&#45;money">¥{{ formatAliAmount(alibabaAftersale.refund_amount) }}</span>
                <span class="gx-detail__val&#45;&#45;money-sub" v-if="alibabaAftersale.refund_carriage > 0">
                        （货款 ¥{{ formatAliAmount(alibabaAftersale.refund_payment) }} + 运费 ¥{{ formatAliAmount(alibabaAftersale.refund_carriage) }}）
                </span>
              </div>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">售后数量</span>
              <span class="gx-detail__val">
                {{ alibabaAftersale.aftersale_num != null ? alibabaAftersale.aftersale_num + ' 件' : '-' }}
              </span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">售后编号</span>
              <span class="gx-detail__val">
                <template v-if="alibabaAftersale.refund_id">
                  <a
                      target="_blank"
                      :href="'https://dispute.1688.com/refund/assureRefundDetail.htm?refundId=' + alibabaAftersale.refund_id"
                  >{{ alibabaAftersale.refund_id }}</a>
                  <i class="gx-detail__copy" @click="copyText(String(alibabaAftersale.refund_id))" >⧉</i>
                </template>
                <template v-else>-</template>
              </span>
            </div>
            <div class="gx-detail__row" v-if="alibabaAftersale.alibaba_order_id">
              <span class="gx-detail__label">采购单号</span>
              <span class="gx-detail__val">
                <a
                    target="_blank"
                    :href="'https://air.1688.com/app/ctf-page/trade-order-detail/index.html?orderId=' + alibabaAftersale.alibaba_order_id"
                >{{ alibabaAftersale.alibaba_order_id }}</a>
                <i class="gx-detail__copy" @click="copyText(String(alibabaAftersale.alibaba_order_id))" >⧉</i>
              </span>
            </div>
            <div class="gx-detail__row">
              <span class="gx-detail__label">上家旺旺</span>
              <span class="gx-detail__val">
                <span>{{ alibabaAftersale.wangwang_account || '-' }}</span>
                <i
                    v-if="alibabaAftersale.wangwang_account || alibabaAftersale.wangwang_chat_url"
                    class="el-icon-chat-dot-round gx-detail__ww"
                    title="打开旺旺"
                    @click="openAlibabaWangwangChat(alibabaAftersale)"
                />
              </span>
            </div>
          </div>
          <div class="gx-detail__ops" v-if="alibabaRefundOperationList.length">
            <div class="gx-detail__ops-hd">退款操作记录</div>
            <div v-if="alibabaRefundOperationListDisplay.length" class="gx-detail__timeline">
              <div v-for="(op, oi) in alibabaRefundOperationListDisplay"
                   :key="'ali-op-' + (op.operation_id || oi) + '-' + (op.gmt_create_time || '')" class="gx-detail__tl-item">
                <span class="gx-detail__tl-dot"></span>
                <div class="gx-detail__tl-body">
                  <div class="gx-detail__tl-time">{{ op.gmt_create_text || '' }}</div>
                  <div class="gx-detail__tl-action">{{ op.operate_remark || op.discription || '操作记录' }}</div>
                  <div class="gx-detail__tl-text" v-if="op.discription && op.operate_remark && op.discription !== op.operate_remark">{{ op.discription }}</div>
                  <div class="gx-detail__tl-kvs">
                    <p v-if="op.after_operate_status"><em>状态</em>：{{ op.after_operate_status_text || op.after_operate_status }}
                      <template v-if="op.before_operate_status && op.before_operate_status !== op.after_operate_status">
                        （原：{{ op.before_operate_status_text || op.before_operate_status }}）
                      </template>
                    </p>
                    <p v-if="op.operator_login_id"><em>操作人</em>：{{ op.operator_login_id }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="alibabaRefundOpsNeedToggle" class="gx-detail__tl-toggle">
              <button  class="gx-detail__link" @click="alibabaRefundOpsExpanded = !alibabaRefundOpsExpanded">
                <template v-if="alibabaRefundOpsExpanded">收起 ▲</template>
                <template v-else>展开全部（共 {{ alibabaRefundOperationList.length }} 条） ▼</template>
              </button>
            </div>
          </div>
          <div class="gx-detail__ops gx-detail__ops-empty" v-else-if="alibabaAftersale.refund_id">
            <div class="gx-detail__ops-hd">退款操作记录</div>
            <p class="gx-detail__ops-empty-tip">暂无操作记录</p>
          </div>
        </div>-->
      </div>
    </div>

    <!-- 售后操作弹窗 -->
    <div v-if="operateDialogVisible" class="gx-modal" @click.self="operateDialogVisible = false">
      <div class="gx-modal-box">
        <div class="gx-modal-head">
          <span class="gx-modal-title">{{ operateDialogTitle }}</span>
          <button class="gx-modal-close" @click="operateDialogVisible = false">✕</button>
        </div>
        <div class="gx-modal-body">
          <div class="gx-detail__field">
            <label class="gx-detail__label">操作类型</label>
            <span>{{ pendingOperate && pendingOperate.text }}</span>
          </div>
          <div v-if="operateNeedReceiverAddress" class="gx-detail__field">
            <label class="gx-detail__label">售后地址</label>
            <select v-model="operateForm.receiver_address_id" class="gx-detail__select" :disabled="returnAddressLoading">
              <option value="">请选择退货地址</option>
              <option v-for="row in returnAddressList" :key="'ra-' + row.dd_address_id" :value="row.dd_address_id">{{ returnAddressOptionLabel(row) }}</option>
            </select>
            <div v-if="operateNeedReceiverAddress && !returnAddressLoading && !returnAddressList.length" class="gx-detail__note">暂无可用退货地址</div>
          </div>
          <div v-if="operateNeedExchangeLogistics" class="gx-detail__field">
            <label class="gx-detail__label">快递公司</label>
            <select v-model="operateForm.company_code" class="gx-detail__select">
              <option value="">请选择快递公司</option>
              <option v-for="c in logisticsCompanyList" :key="c.code" :value="c.code">{{ c.name }}</option>
            </select>
          </div>
          <div v-if="operateNeedExchangeLogistics" class="gx-detail__field">
            <label class="gx-detail__label">物流单号</label>
            <input v-model="operateForm.logistics_code" class="gx-detail__input" placeholder="请输入换货发货物流单号" />
          </div>
          <div v-if="operateNeedReject" class="gx-detail__field">
            <label class="gx-detail__label">拒绝原因</label>
            <select v-model="operateForm.reject_reason_code" class="gx-detail__select">
              <option value="">请选择</option>
              <option v-for="r in rejectReasonList" :key="r.reject_reason_code" :value="r.reject_reason_code">{{ r.reason }}</option>
            </select>
          </div>
          <div v-if="operateNeedEvidence" class="gx-detail__field">
            <label class="gx-detail__label">凭证说明</label>
            <textarea v-model="operateForm.evidence_content" class="gx-detail__textarea" rows="3" placeholder="请填写说明"></textarea>
            <div class="gx-detail__upload">
              <button class="gx-detail__btn" @click="$refs.evidenceFile && $refs.evidenceFile.click()">上传凭证</button>
              <input ref="evidenceFile" type="file" accept="image/*" style="display: none" @change="uploadEvidence" />
              <img v-if="operateForm.evidence_url" :src="operateForm.evidence_url" class="gx-detail__upload-img" alt="" />
            </div>
          </div>
        </div>
        <div class="gx-modal-foot">
          <button class="gx-modal-foot-btn" @click="operateDialogVisible = false">取消</button>
          <button class="gx-modal-foot-btn gx-modal-foot-btn--yellow" :disabled="operateSubmitting || operateConfirmDisabled" @click="confirmOperate">{{ operateSubmitting ? '提交中...' : '确定' }}</button>
        </div>
      </div>
    </div>

    <!-- 图片预览 -->
    <div v-if="imgPreview" class="gx-modal" @click.self="imgPreview = false">
      <div class="gx-modal-box gx-detail__modal-box--lg">
        <div class="gx-modal-head">
          <span class="gx-modal-title">凭证图片</span>
          <button class="gx-modal-close" @click="imgPreview = false">✕</button>
        </div>
        <div class="gx-modal-body">
          <img :src="imgPreviewUrl" class="gx-detail__preview-img" alt="" />
        </div>
      </div>
    </div>

    <!-- 备注弹窗（复用原版组件） -->
    <aftersale-remark-dialog
        :visible.sync="remarkDialogVisible"
        :aftersale-id="aftersaleIdForDialog"
        :order-id="orderIdForRemarkDialog"
        :initial-tab="remarkDialogInitialTab"
        :initial-remark="remarkInitialForDialog"
        @success="onRemarkDialogSuccess"
    />
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import GxLoading from '../../components/newUi/GxLoading.vue'
import TopBanner from '../../components/newUi/TopBanner.vue'
import newUiPermissionMixin from '../../mixins/newUiPermission'
import AftersaleRemarkDialog from '../uc_after_sales/components/AftersaleRemarkDialog.vue'
import { uploadDirectOss } from '../../assets/js/utils/ossDirectUpload'

const DD_STATUS = {
  WAIT_SELLER_PASS: 6,
  WAIT_BUYER_RETURN: 7,
  WAIT_SELLER_AGAIN: 11,
  SUCCESS: 12
}

const PLACEHOLDER = {
  orderTime: '2026-04-26 12:36:42',
  timeline: [
    '【示例】消费者：发起了退货退款申请…',
    '【示例】系统：因该用户信誉良好，系统自动同意退货申请',
    '【示例】系统：预约驿站寄件成功'
  ]
}

const NEGOTIATION_PREVIEW_LEN = 3
const EXTEND_RECEIPT_MAX_REMAIN_SEC = 2 * 86400

export default {
  name: 'AfterSalesDetail',
  components: { AftersaleRemarkDialog, GxLoading,  },
  mixins: [newUiPermissionMixin],
  props: {
    aftersaleId: { type: [Number, String], default: '' },
    embedded: { type: Boolean, default: false }
  },
  data() {
    return {
      PLACEHOLDER,

      pageLoading: false,
      loadError: '',
      aftersale: null,
      operateList: [],
      orderDetail: null,
      orderProduct: null,
      countdownTimer: null,
      countdownText: '',
      logisticsTab: 'order',
      operateDialogVisible: false,
      pendingOperate: null,
      operateForm: {
        reject_reason_code: '',
        evidence_content: '',
        evidence_url: '',
        receiver_address_id: '',
        company_code: '',
        logistics_code: ''
      },
      operateSubmitting: false,
      returnAddressList: [],
      returnAddressLoading: false,
      rejectReasonList: [],
      logisticsCompanyList: [],
      primaryOperateVals: [111, 201, 101, 301, 121, 311],
      negotiationExpanded: false,
      remarkDialogVisible: false,
      remarkDialogInitialTab: 'aftersale',
      extendReceiptSubmitting: false,
      logisticsInterceptSubmitting: false,
      aftersaleProcessList: [],
      processFlowStatus: '',
      processCurrentKey: null,
      alibabaOrderRefundId: '',
      alibabaOrderRefundStatusText: '',
      alibabaAftersale: null,
      alibabaRefundOperationList: [],
      alibabaRefundOpsExpanded: false,
      imgPreview: false,
      imgPreviewUrl: ''

    }
  },
  computed: {

    afterId() {
      if (this.aftersaleId !== '' && this.aftersaleId != null) {
        const id = parseInt(this.aftersaleId, 10)
        return Number.isFinite(id) ? id : 0
      }
      const q = this.$route.query.id
      const id = parseInt(q, 10)
      return Number.isFinite(id) ? id : 0
    },
    aftersaleIdForDialog() {
      return this.aftersale && this.aftersale.id != null ? Number(this.aftersale.id) : 0
    },
    textPart() {
      const tp = this.aftersale && this.aftersale.text_part
      if (!tp || typeof tp !== 'object' || Array.isArray(tp)) return {}
      return tp
    },
    recordLogs() {
      const r = this.aftersale && this.aftersale.record_logs_list
      return Array.isArray(r) ? r : []
    },
    timelineRecords() {
      return this.recordLogs
    },
    negotiationTotal() {
      const n = this.timelineRecords.length
      return n > 0 ? n : PLACEHOLDER.timeline.length
    },
    negotiationNeedToggle() {
      return this.negotiationTotal > NEGOTIATION_PREVIEW_LEN
    },
    timelineRecordsDisplay() {
      const list = this.timelineRecords
      if (!list.length) return []
      if (this.negotiationExpanded || list.length <= NEGOTIATION_PREVIEW_LEN) return list
      return list.slice(-NEGOTIATION_PREVIEW_LEN)
    },
    placeholderTimelineDisplay() {
      const arr = PLACEHOLDER.timeline
      if (this.negotiationExpanded || arr.length <= NEGOTIATION_PREVIEW_LEN) return arr
      return arr.slice(-NEGOTIATION_PREVIEW_LEN)
    },
    statusHeadline() {
      return this.textPart.aftersale_status_text || '售后处理'
    },
    typeTagText() {
      return this.textPart.aftersale_type_text || '退货退款'
    },
    reasonText() {
      return this.textPart.reason_text || '-'
    },
    applyTimeText() {
      return this.aftersale.apply_time_text || this.aftersale.apply_time || '-'
    },
    shopOrderId() {
      return this.aftersale ? String(this.aftersale.shop_order_id || '') : ''
    },
    showAlibabaOrderRefundInfo() {
      const id = this.alibabaOrderRefundId
      return id != null && String(id).trim() !== ''
    },
    orderCreateTime() {
      return this.orderDetail && this.orderDetail.create_time
    },
    stepActiveIndex() {
      const st = this.aftersale ? Number(this.aftersale.aftersale_status) : 0
      const tp = this.aftersale ? Number(this.aftersale.aftersale_type) : 0
      if (tp !== 0) {
        if (st === DD_STATUS.WAIT_SELLER_PASS) return 1
        if (st === DD_STATUS.WAIT_BUYER_RETURN) return 2
        if (st === DD_STATUS.WAIT_SELLER_AGAIN) return 3
        if (st === DD_STATUS.SUCCESS || st > DD_STATUS.SUCCESS) return 4
      }
      return 3
    },
    sortedProcessSteps() {
      const list = this.aftersaleProcessList
      if (!Array.isArray(list) || !list.length) return []
      return [...list].sort((a, b) => (Number(a.step_no) || 0) - (Number(b.step_no) || 0))
    },
    processStepBarList() {
      const api = this.sortedProcessSteps
      if (api.length) {
        return api.map((step, idx) => {
          const st = step.step_status
          let uiState = 'wait'
          if (st === 'completed') uiState = 'done'
          else if (st === 'active') uiState = 'current'
          else if (st === 'failed') uiState = 'error'
          return { key: String(step.key || step.step_no || idx) + '-' + idx, title: step.title || '步骤' + (Number(step.step_no) || idx + 1), uiState }
        })
      }
      const titles = ['用户申请退货', '同意申请', '买家寄回', '退款成功', '售后完成']
      const act = this.stepActiveIndex
      const st = this.aftersale ? Number(this.aftersale.aftersale_status) : 0
      const allDone = st === DD_STATUS.SUCCESS || st > DD_STATUS.SUCCESS
      return titles.map((title, idx) => {
        let uiState = 'wait'
        if (allDone) uiState = 'done'
        else if (idx < act) uiState = 'done'
        else if (idx === act) uiState = 'current'
        return { key: 'tpl-' + idx, title, uiState }
      })
    },
    showExtendReceiptStub() {
      const a = this.aftersale
      if (!a) return false
      if (Number(a.aftersale_status) !== DD_STATUS.WAIT_SELLER_AGAIN) return false
      let ts = parseInt(a.status_deadline, 10)
      if (!ts || ts <= 0) return false
      if (ts > 1e12) ts = Math.floor(ts / 1000)
      const nowSec = Math.floor(Date.now() / 1000)
      if (ts <= nowSec) return false
      const remaining = ts - nowSec
      return remaining > 0 && remaining < EXTEND_RECEIPT_MAX_REMAIN_SEC
    },
    showLogisticsInterceptUi() {
      const a = this.aftersale
      if (!a) return false
      return Number(a.aftersale_type) === 1 && Number(a.aftersale_status) === DD_STATUS.WAIT_SELLER_PASS
    },
    logisticsInterceptStateNum() {
      const a = this.aftersale
      if (!a) return 0
      const s = Number(a.logistics_intercept_state)
      return Number.isNaN(s) ? 0 : s
    },
    logisticsInterceptStatusText() {
      const map = { 1: '物流拦截中', 2: '物流拦截成功', 3: '物流拦截失败' }
      const n = this.logisticsInterceptStateNum
      if (map[n]) return map[n]
      if (n > 0) return `物流拦截状态(${n})`
      return ''
    },
    logisticsInterceptTagType() {
      const n = this.logisticsInterceptStateNum
      if (n === 1) return 'warn'
      if (n === 2) return 'ok'
      if (n === 3) return 'fail'
      return 'info'
    },
    returnAddressText() {
      const a = this.aftersale;
      if (a && a.return_address) return this.extractReturnAddress(a.return_address);
      const fromKv = this.extractReturnAddressFromLogs();
      return fromKv || '-';
    },
    consumerRefundText() {
      const a = this.aftersale
      if (!a) return '-'
      const post = Number(a.refund_post_amount)
      const total = Number(a.refund_amount)
      if (!Number.isNaN(post) && !Number.isNaN(total)) {
        return this.formatYuan(Math.max(0, total - post))
      }
      return this.formatYuan(a.refund_amount)
    },
    receiptStatusText() {
      return this.textPart.return_logistics_text || this.textPart.logistics_text || '-'
    },
    returnNumText() {
      if (this.aftersale && this.aftersale.return_logistics_code) {
        return (this.aftersale.aftersale_num != null ? this.aftersale.aftersale_num : '1') + ' 件'
      }
      return '-'
    },
    buyerRemark() {
      return this.aftersale && this.aftersale.remark
    },
    remarkInitialForDialog() {
      const r = this.aftersale && this.aftersale.remark
      return r != null && r !== '' ? String(r) : ''
    },
    orderIdForRemarkDialog() {
      const oid = this.aftersale && this.aftersale.order_id
      if (oid == null || oid === '') return 0
      const n = Number(oid)
      return Number.isFinite(n) ? n : 0
    },
    orderDetailSellerWordsDisplay() {
      const w = this.orderDetail && this.orderDetail.seller_words
      if (w == null || String(w).trim() === '') return '—'
      return String(w)
    },
    orderSellerRemarkFlagShow() {
      const d = this.orderDetail
      if (!d) return false
      if (d.seller_remark_starts_info && typeof d.seller_remark_starts_info === 'object') return true
      if (d.seller_remark_stars != null && d.seller_remark_stars !== '') return true
      return false
    },
    orderSellerRemarkFlagColor() {
      const d = this.orderDetail
      if (!d) return '#c0c4cc'
      const info = d.seller_remark_starts_info
      if (info && typeof info === 'object' && info.color) return info.color
      return '#c0c4cc'
    },
    shipStatusText() {
      return this.textPart.logistics_text || '已发货'
    },
    userPaidText() {
      if (this.orderDetail && this.orderDetail.pay_amount != null) {
        return '￥' + this.orderDetail.pay_amount
      }
      return this.formatYuan(this.aftersale && this.aftersale.refund_amount)
    },
    orderLogistics() {
      const d = this.orderDetail
      if (!d) return { company: '-', no: '-', time: '-' }
      const del = (d.supplier_order_delivery && d.supplier_order_delivery[0]) || {}
      if (del.company || del.logistics_code) {
        return { company: del.company || '-', no: del.logistics_code || '-', time: del.update_time || '-' }
      }
      if (d.dd_order_print) {
        return { company: d.dd_order_print.logistics_company || '-', no: d.dd_order_print.track_no || '-', time: '-' }
      }
      return { company: '-', no: '-', time: '-' }
    },
    returnLogistics() {
      const a = this.aftersale
      if (!a) return { company: '-', no: '', time: '-' }
      return { company: a.return_logistics_company_name || '-', no: a.return_logistics_code || '', time: a.return_logistics_time_text || '-' }
    },
    exchangeLogistics() {
      const a = this.aftersale
      if (!a) return { company: '-', no: '', time: '-' }
      return { company: a.exchange_logistics_company_name || '-', no: a.exchange_logistics_code || '', time: a.exchange_logistics_time_text || '-' }
    },
    operateDialogTitle() {
      return this.pendingOperate ? `确认操作：${this.pendingOperate.text}` : '售后操作'
    },
    operateNeedReject() {
      return this.opOther(this.pendingOperate).includes('reject_reason_code')
    },
    operateNeedEvidence() {
      return this.opOther(this.pendingOperate).includes('evidence')
    },
    operateNeedReceiverAddress() {
      return this.opOther(this.pendingOperate).includes('Logistics.ReceiverAddressId')
    },
    operateNeedExchangeLogistics() {
      const other = this.opOther(this.pendingOperate)
      return other.includes('logistics.companyCode') || other.includes('logistics.logisticsCode')
    },
    operateConfirmDisabled() {
      return this.operateNeedReceiverAddress && this.returnAddressLoading
    },
    alibabaRefundOpsNeedToggle() {
      return this.alibabaRefundOperationList.length > NEGOTIATION_PREVIEW_LEN;
    },
    /** 接口已按时间倒序（最新在前），收起时保留前几条最新记录 */
    alibabaRefundOperationListDisplay() {
      const list = this.alibabaRefundOperationList;
      if (!list.length) return [];
      if (this.alibabaRefundOpsExpanded || list.length <= NEGOTIATION_PREVIEW_LEN) return list;
      return list.slice(0, NEGOTIATION_PREVIEW_LEN);
    },
    alibabaProduct() {
      const a = this.alibabaAftersale;
      return a && a.product && typeof a.product === 'object' ? a.product : null;
    }
  },
  created() {
    this.$store.dispatch('notification/initNotificationWS')
    this.bootstrap()
  },
  beforeDestroy() {
    if (this.countdownTimer) clearInterval(this.countdownTimer)
  },
  methods: {
    ...mapMutations({
      OUT_LOGIN: 'login/OUT_LOGIN'
    }),
    ...mapActions({
      getDdAftersaleDetail: 'ucenter_order/getDdAftersaleDetail',
      opDdAftersaleOperate: 'ucenter_order/opDdAftersaleOperate',
      opDdAftersaleTimeExtend: 'ucenter_order/opDdAftersaleTimeExtend',
      opDdAftersaleApplyLogisticsIntercept: 'ucenter_order/opDdAftersaleApplyLogisticsIntercept',
      getDdReturnAddressList: 'ucenter_order/getDdReturnAddressList',
      getOrderManageDetail: 'ucenter_order/getOrderManageDetail',
      getOrderServerGetOperateInfo: 'ucenter_order/getOrderServerGetOperateInfo'
    }),
    opOther(op) {
      return Array.isArray(op && op.other) ? op.other : []
    },
    bootstrap() {
      if (!this.afterId) {
        this.loadError = '缺少售后记录 id'
        return
      }
      this.pageLoading = true
      this.loadError = ''
      this.getDdAftersaleDetail({
        data: { id: this.afterId },
        success: (res) => {
          if (res.code !== 200) {
            this.loadError = res.msg || '加载失败'
            this.pageLoading = false
            return
          }
          const data = res.data || {}
          this.aftersale = data.aftersale || null
          this.operateList = data.operate_type_list || []
          this.logisticsCompanyList = Array.isArray(data.logistics_company_list) ? data.logistics_company_list : []
          this.syncProcessFromDetail(data)
          this.syncAlibabaOrderRefundFromDetail(data)
          this.negotiationExpanded = false
          if (!this.aftersale) {
            this.loadError = '数据为空'
            this.pageLoading = false
            return
          }
          this.startCountdown()
          this.fetchOrderDetail()
          this.pageLoading = false
        }
      })
    },
    syncProcessFromDetail(data) {
      const d = data || {}
      this.aftersaleProcessList = Array.isArray(d.aftersale_process_list) ? d.aftersale_process_list : []
      this.processFlowStatus = d.process_flow_status || ''
      this.processCurrentKey = Object.prototype.hasOwnProperty.call(d, 'process_current_key') ? d.process_current_key : null
    },
    syncAlibabaOrderRefundFromDetail(data) {
      const d = data || {}
      const ali = d.alibaba_aftersale && typeof d.alibaba_aftersale === 'object' ? d.alibaba_aftersale : null;
      this.alibabaAftersale = ali;
      this.alibabaRefundOperationList = Array.isArray(d.alibaba_refund_operation_list)
          ? d.alibaba_refund_operation_list
          : [];
      this.alibabaRefundOpsExpanded = false;
      if (ali) {
        this.alibabaOrderRefundId = ali.refund_id != null ? String(ali.refund_id) : '';
        this.alibabaOrderRefundStatusText = ali.refund_status_text != null
            ? String(ali.refund_status_text)
            : '';
        return;
      }
      this.alibabaOrderRefundId = d.alibaba_order_refund_id != null ? String(d.alibaba_order_refund_id) : ''
      this.alibabaOrderRefundStatusText = d.alibaba_order_refund_status_text != null ? String(d.alibaba_order_refund_status_text) : ''
    },
    refreshAftersaleDetail() {
      if (!this.afterId) return
      this.getDdAftersaleDetail({
        data: { id: this.afterId },
        success: (res) => {
          if (res.code !== 200 || !res.data) return
          this.aftersale = res.data.aftersale || this.aftersale
          this.operateList = res.data.operate_type_list || this.operateList
          if (Array.isArray(res.data.logistics_company_list)) {
            this.logisticsCompanyList = res.data.logistics_company_list
          }
          this.syncProcessFromDetail(res.data)
          this.syncAlibabaOrderRefundFromDetail(res.data)
          this.negotiationExpanded = false
          if (this.aftersale) this.startCountdown()
        }
      })
    },
    fetchOrderDetail() {
      const oid = this.aftersale && this.aftersale.order_id
      if (!oid) return
      this.getOrderManageDetail({
        data: { order_id: oid },
        success: (res) => {
          if (res.code !== 200 || !res.data) return
          this.orderDetail = res.data
          const pid = this.aftersale.order_product_id
          const list = res.data.order_product || []
          const row = list.find((p) => p.id == pid) || list[0]
          this.orderProduct = row || null
        }
      })
    },
    openRemarkDialog(tab = 'aftersale') {
      if (!this.aftersale || !this.aftersale.id) {
        this.$message.warning('售后数据未就绪')
        return
      }
      this.remarkDialogInitialTab = tab === 'order' ? 'order' : 'aftersale'
      this.remarkDialogVisible = true
    },
    onRemarkDialogSuccess() {
      this.refreshAftersaleDetail()
      this.fetchOrderDetail()
    },
    confirmExtendReceipt() {
      if (!this.aftersale || !this.aftersale.id) return
      if (!this.showExtendReceiptStub) return
      this.$confirm('确认向抖店申请延长售后收货时限？', '延长收货', {
        type: 'warning',
        confirmButtonText: '确认延长',
        cancelButtonText: '取消'
      }).then(() => {
        if (this.extendReceiptSubmitting) return
        this.extendReceiptSubmitting = true
        this.opDdAftersaleTimeExtend({
          data: { id: this.aftersale.id },
          success: (res) => {
            this.extendReceiptSubmitting = false
            if (res.code === 200) {
              this.$message.success(res.msg || '申请成功')
              this.refreshAftersaleDetail()
            } else {
              this.$message.error(res.msg || '申请失败')
            }
          }
        })
      }).catch(() => {})
    },
    confirmApplyLogisticsIntercept() {
      if (!this.aftersale || !this.aftersale.id) return
      if (this.logisticsInterceptStateNum !== 0) return
      this.$confirm('确认向抖店申请物流拦截？将按当前子订单发货运单发起拦截。', '申请物流拦截', {
        type: 'warning',
        confirmButtonText: '确认申请',
        cancelButtonText: '取消'
      }).then(() => {
        if (this.logisticsInterceptSubmitting) return
        this.logisticsInterceptSubmitting = true
        this.opDdAftersaleApplyLogisticsIntercept({
          data: { id: this.aftersale.id },
          success: (res) => {
            this.logisticsInterceptSubmitting = false
            if (res.code === 200) {
              this.$message.success(res.msg || '申请已提交')
              this.refreshAftersaleDetail()
            } else {
              this.$message.error(res.msg || '申请失败')
            }
          }
        })
      }).catch(() => {})
    },
    startCountdown() {
      if (this.countdownTimer) clearInterval(this.countdownTimer)
      this.countdownText = ''
      const raw = this.aftersale && this.aftersale.status_deadline
      const ts = parseInt(raw, 10)
      if (!ts || ts <= 0) return
      const endMs = ts < 1e12 ? ts * 1000 : ts
      const tick = () => {
        const left = Math.floor((endMs - Date.now()) / 1000)
        if (left <= 0) {
          this.countdownText = '00 秒'
          clearInterval(this.countdownTimer)
          this.countdownTimer = null
          return
        }
        const d = Math.floor(left / 86400)
        const restAfterDay = left % 86400
        const h = Math.floor(restAfterDay / 3600)
        const m = Math.floor((restAfterDay % 3600) / 60)
        const s = restAfterDay % 60
        const parts = []
        if (d > 0) parts.push(`${d} 天`)
        if (d > 0 || h > 0) parts.push(`${h} 小时`)
        parts.push(`${m} 分`, `${s} 秒`)
        this.countdownText = parts.join(' ')
      }
      tick()
      this.countdownTimer = setInterval(tick, 1000)
    },
    formatYuan(v) {
      if (v === '' || v == null) return '-'
      const n = Number(v)
      if (Number.isNaN(n)) return String(v)
      return '￥' + n.toFixed(2)
    },
    copyText(text) {
      if (!text) return
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('Copy')
      document.body.removeChild(input)
      this.$message.success('已复制')
    },
    negotiationEvidenceBlocks(rec) {
      const raw = rec && rec.all_evidence
      if (!Array.isArray(raw) || !raw.length) return []
      const blocks = []
      for (const ev of raw) {
        if (!ev || typeof ev !== 'object') continue
        let urls = []
        if (Array.isArray(ev.urls)) {
          urls = ev.urls.map((u) => (u == null ? '' : String(u).trim())).filter(Boolean)
        } else if (ev.url) {
          urls = [String(ev.url).trim()].filter(Boolean)
        }
        const desc = ev.desc != null && String(ev.desc).trim() !== '' ? String(ev.desc).trim() : ''
        if (!urls.length && !desc) continue
        blocks.push({ desc, urls })
      }
      return blocks
    },
    negotiationEvidenceAllUrls(rec) {
      return this.negotiationEvidenceBlocks(rec).reduce((acc, b) => acc.concat(b.urls), [])
    },
    previewImg(url) {
      if (!url) return
      this.imgPreviewUrl = url
      this.imgPreview = true
    },
    /**
     *  ── 售后操作 ── */
    openOperate(op) {
      const other = this.opOther(op)
      const needForm =
          other.includes('reject_reason_code') ||
          other.includes('evidence') ||
          other.includes('Logistics.ReceiverAddressId') ||
          other.includes('logistics.companyCode') ||
          other.includes('logistics.logisticsCode')
      if (!needForm) {
        this.$confirm(`确认执行「${op.text}」？`, '提示', { type: 'warning' })
            .then(() => this.submitOperate(op, {}))
            .catch(() => {})
        return
      }
      this.pendingOperate = op
      this.returnAddressList = []
      const exchangeLogistics = this.defaultExchangeLogisticsForm()
      this.operateForm = {
        reject_reason_code: '',
        evidence_content: '',
        evidence_url: '',
        receiver_address_id: '',
        company_code: exchangeLogistics.company_code,
        logistics_code: exchangeLogistics.logistics_code
      }
      this.operateDialogVisible = true
      if (other.includes('reject_reason_code')) this.prefetchRejectReasons()
      if (other.includes('Logistics.ReceiverAddressId')) this.fetchReturnAddressList()
    },
    defaultExchangeLogisticsForm() {
      const a = this.aftersale || {}
      const d = this.orderDetail || {}
      const print = (d && d.dd_order_print) || {}
      let companyCode = a.exchange_logistics_company_code || print.logistics_code || ''
      if (companyCode && this.logisticsCompanyList.length) {
        const hit = this.logisticsCompanyList.find((c) => String(c.code) === String(companyCode))
        if (!hit) companyCode = ''
      }
      return { company_code: companyCode, logistics_code: a.exchange_logistics_code || '' }
    },
    fetchReturnAddressList() {
      const a = this.aftersale
      if (!a || a.id == null) return
      this.returnAddressLoading = true
      this.getDdReturnAddressList({
        data: { id: a.id },
        success: (res) => {
          this.returnAddressLoading = false
          if (res.code !== 200) {
            this.$message.error(res.msg || '加载退货地址失败')
            return
          }
          const list = (res.data && res.data.address_list) || []
          this.returnAddressList = Array.isArray(list) ? list : []
          const rid = a.return_address_id
          const notZero = rid != null && rid !== '' && rid !== 0 && String(rid) !== '0'
          if (notZero) {
            const hit = this.returnAddressList.find((x) => String(x.dd_address_id) === String(rid))
            if (hit) this.operateForm.receiver_address_id = hit.dd_address_id
          }
        }
      })
    },
    returnAddressOptionLabel(row) {
      if (!row || typeof row !== 'object') return ''
      let base = ''
      if (row.full_name != null && String(row.full_name).trim()) {
        base = String(row.full_name).trim()
      } else {
        try {
          base = this.extractReturnAddress(row)
        } catch (e) {
          base = ''
        }
      }
      if (!base) base = row.dd_address_id != null ? String(row.dd_address_id) : ''
      const tagText = row.tag === 1 ? '当前订单' : row.tag === 2 ? '当前商品策略' : row.tag === 3 ? '抖店售后地址' : ''
      return tagText ? `${base} [${tagText}]` : base
    },
    extractReturnAddress(return_address) {
      if (!return_address) return ''
      return [return_address.name, return_address.phone, return_address.province, return_address.city, return_address.town, return_address.street, return_address.detail].filter(Boolean).join(' ')
    },
    prefetchRejectReasons() {
      const a = this.aftersale
      if (!a) return
      this.getOrderServerGetOperateInfo({
        data: { order_id: a.order_id, aftersale_id: a.aftersale_id },
        success: (res) => {
          if (res.code === 200) {
            this.rejectReasonList = res.data.reject_reason_list || []
          }
        }
      })
    },
    async uploadEvidence(e) {
      const file = e.target.files && e.target.files[0]
      if (!file) return
      try {
        const data = await uploadDirectOss(file, { purpose: 'merchant_image' })
        if (!data.url) throw new Error('上传接口未返回图片地址')
        this.operateForm.evidence_url = data.url
        this.$message.success('上传成功')
      } catch (error) {
        this.$message.error(error.message || '上传失败')
      } finally {
        e.target.value = ''
      }
    },
    confirmOperate() {
      const op = this.pendingOperate
      if (!op) return
      if (this.operateNeedReject && !this.operateForm.reject_reason_code) {
        this.$message.warning('请选择拒绝原因')
        return
      }
      if (this.operateNeedEvidence && !String(this.operateForm.evidence_content || '').trim()) {
        this.$message.warning('请填写说明')
        return
      }
      if (this.operateNeedReceiverAddress) {
        if (this.returnAddressLoading) return
        if (this.returnAddressList.length && !this.operateForm.receiver_address_id) {
          this.$message.warning('请选择售后退货地址')
          return
        }
      }
      if (this.operateNeedExchangeLogistics) {
        if (!this.operateForm.company_code) {
          this.$message.warning('请选择快递公司')
          return
        }
        if (!String(this.operateForm.logistics_code || '').trim()) {
          this.$message.warning('请填写物流单号')
          return
        }
      }
      this.submitOperate(op, {
        reject_reason_code: this.operateForm.reject_reason_code,
        evidence_content: this.operateForm.evidence_content,
        evidence_url: this.operateForm.evidence_url,
        receiver_address_id: this.operateForm.receiver_address_id,
        company_code: this.operateForm.company_code,
        logistics_code: this.operateForm.logistics_code
      })
    },
    submitOperate(op, extra) {
      if (!op || !this.aftersale) return
      if (this.operateSubmitting) return
      const payload = {
        id: this.aftersale.id,
        type: op.val,
        evidence_content: extra.evidence_content || '',
        evidence_url: extra.evidence_url || ''
      }
      if (this.opOther(op).includes('reject_reason_code')) {
        payload.reject_reason_code = extra.reject_reason_code
      }
      if (this.opOther(op).includes('Logistics.ReceiverAddressId') && extra.receiver_address_id !== '' && extra.receiver_address_id != null) {
        payload.receiver_address_id = extra.receiver_address_id
      }
      const other = this.opOther(op)
      if (other.includes('logistics.companyCode') || other.includes('logistics.logisticsCode')) {
        payload.company_code = extra.company_code
        payload.logistics_code = String(extra.logistics_code || '').trim()
      }
      this.operateSubmitting = true
      this.opDdAftersaleOperate({
        data: payload,
        success: (res) => {
          this.operateSubmitting = false
          if (res.code === 200) {
            this.$message.success(res.msg || '操作成功')
            this.operateDialogVisible = false
            this.refreshAftersaleDetail()
          } else {
            this.$message.error(res.msg || '操作失败')
          }
        }
      })
    },

    /**
     * ── 1688售后详情 ── */
    formatAliAmount(v) {
      const n = Number(v);
      if (!Number.isFinite(n)) return '0.00';
      return n.toFixed(2);
    },
    openAlibabaWangwangChat(ali) {
      const row = ali || this.alibabaAftersale || {};
      const url = String(row.wangwang_chat_url || '').trim();
      if (url) {
        window.open(url, '_blank');
        return;
      }
      const account = String(row.wangwang_account || '').trim();
      if (!account) {
        this.$message({ message: '暂无上家旺旺', type: 'warning' });
        return;
      }
      const wangwangId = account.replace(/^cnalichn/i, '');
      const touid = encodeURIComponent('cnalichn' + wangwangId);
      window.open(
          `https://air.1688.com/app/ocms-fusion-components-1688/def_cbu_web_im/index.html?&touid=${touid}&siteid=cnalichn&status=1&portalId=&gid=&offerId=&itemsId=&spmid=a261y.7663282.0#/`,
          '_blank'
      );
    },
    openAlibabaOfferDetail(product) {
      const p = product || this.alibabaProduct || {};
      let url = String(p.offer_url || '').trim();
      if (!url && p.offer_id) {
        const id = String(p.offer_id).trim();
        url = `https://detail.1688.com/offer/${id}.html?offerId=${id}`;
      }
      if (!url) {
        this.$message({ message: '暂无1688商品链接', type: 'warning' });
        return;
      }
      window.open(url, '_blank');
    },
  }
}
</script>

<style scoped>

.gx-detail {
  font-family: 'Noto Sans SC', sans-serif;
  background: transparent;
}
.gx-detail__head {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 2px 0 12px;
  background: transparent;
  border-bottom: none;
}
.gx-detail__back {
  display: flex;
  align-items: center;
  gap: 5px;
  height: 30px;
  padding: 0px 12px;
  border-radius: 5px;
  cursor: pointer;
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: rgb(200, 68, 60);
}

.gx-detail__head-title {
  font-size: 16px;
  font-weight: 700;
  color: #1A1A2E;
}
.gx-detail__error {
  background: #FFFFFF;
  margin: 24px;
  padding: 48px;
  text-align: center;
  border-radius: 8px;
  color: #F04E45;
}
.gx-detail__layout {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 0;
}
.gx-detail__main {
  flex: 1;
  min-width: 0;
}
.gx-detail__side {
  width: 40vw;
  flex-shrink: 0;
}
.gx-detail__card {
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 2px solid rgb(224, 224, 236);
  padding: 14px 16px ;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 4px;
  margin-bottom: 14px;
}
.gx-detail__card-hd {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 10px;
  gap: 8px;
  border-bottom: 1px solid #F2F3F7;
}
.gx-detail__card-title {
  font-family: "Noto Serif SC", serif;
  font-size: 13px;
  font-weight: 600;
  color: rgb(26, 26, 46);
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 14px;
}
.gx-detail__card-title-bar{
  width: 3px;
  height: 13px;
  border-radius: 1px;
  background:var(--gx-red);
}
.gx-detail__card-title-bar--blue{
  background:var(--gx-cyan);
}
.gx-detail__card-title-bar--orange{
  background:var(--gx-orange);
}
.gx-detail__card-title-bar--green{
  background:var(--gx-green);
}
.gx-detail__card-hd .gx-detail__card-title{
  margin-bottom: 0;
}

.gx-detail__card-count {
  font-size: 12px;
  font-weight: 400;
  color: #909399;
}

.gx-detail__steps {
  width: 100%;
  display: flex;
  align-items: flex-start;
  margin-bottom: 18px;
}
.gx-detail__step {
  display: flex;
  align-items: flex-start;
  flex: 1 1 0;
  min-width: 0;
}
.gx-detail__step:first-child {
  flex: 0 0 auto;
}
.gx-detail__step-node {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  width: 76px;
  white-space: nowrap;
}
.gx-detail__step-icon {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(245, 245, 245);
  border: 2px solid rgb(224, 224, 236);
  font-family: "JetBrains Mono", monospace;
  font-size: 12px;
  font-weight: 700;
  color: rgb(106, 106, 138);
  box-sizing: border-box;
}
.gx-detail__step--done .gx-detail__step-icon,
.gx-detail__step--current .gx-detail__step-icon {
  background: linear-gradient(135deg, rgb(212, 169, 70), rgb(232, 185, 80));
  border: 2px solid rgb(200, 68, 60);
  color: #ffffff;
}
.gx-detail__step--error .gx-detail__step-icon {
  background: #FDECEA;
  color:var(--gx-red);
  border: 1px solid var(--gx-red);
}
.gx-detail__step-title {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  color: rgb(106, 106, 138);
  margin-top: 4px;
}
.gx-detail__step--done .gx-detail__step-title,
.gx-detail__step--current .gx-detail__step-title {
  color: var(--gx-red);
}
.gx-detail__step--error .gx-detail__step-title {
  color: var(--gx-red);
}
.gx-detail__step-line {
  flex: 1 1 16px;
  min-width: 16px;
  height: 2px;
  margin: 12px 4px 0;
  background: #DDE2EC;
  border: none;
}
.gx-detail__step-line--red {
  background: var(--gx-red);
}
.gx-detail__step--done .gx-detail__step-line {
  background: linear-gradient(90deg, #D4A946, #E8C778);
}
.gx-detail__divide{
  margin: 10px 0;
  width: 100%;
  height: 1px;
  background: rgb(224, 224, 236);
}

.gx-detail__status-title {
  font-size: 14px;
  font-weight: 700;
  color: #1A1A2E;
}
.gx-detail__countdown {
  font-size: 12px;
  color: var(--gx-red);
}
.gx-detail__countdown-num {
  font-family: 'JetBrains Mono', monospace;
  font-weight: 700;
}
.gx-detail__actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 10px;
  border-top: 1px solid rgb(224, 224, 236);
}

.gx-detail__actions--bar .gx-detail__countdown {
  margin: 0;
  margin-right: auto;
  white-space: nowrap;
}
.gx-detail__btn {
  height: 30px;
  padding: 0 15px;
  border-radius: 6px;
  cursor: pointer;
  background: #FFFFFF;
  border: 1px solid rgb(224, 224, 236);
  font-weight: 400;
  font-size: 12px;
  color: rgb(74, 74, 106);
  transition: all .16s;
  white-space: nowrap;
}
.gx-detail__btn--sm{
  height: 26px;
  padding: 0 9px;
  font-size: 11px;
  transition: 0.15s;
}
.gx-detail__btn:hover:not(:disabled) {
  border-color: rgb(224,224,236);
  background: rgb(240,237,232);
  color:var(--gx-black);
}
.gx-detail__btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-detail__btn--primary {
  background: rgb(230, 244, 255);
  border: 1px solid rgb(145, 202, 255);
  color: var(--gx-cyan);
}
.gx-detail__btn--primary:hover:not(:disabled) {
  background: var(--gx-cyan);
  color: #FFFFFF;
}
.gx-detail__remark-line {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #4A4A6A;
  margin: 6px 0;
  flex-wrap: wrap;
}
.gx-detail__remark-k {
  color: #6A6A8A;
  flex-shrink: 0;
}
.gx-detail__remark-val {
  color: #1A1A2E;
}
.gx-detail__flag {
  font-style: normal;
}
.gx-detail__link {
  color: var(--gx-cyan);
  cursor: pointer;
  text-decoration: none;
}
.gx-detail__link:hover {
  text-decoration: underline;
}
.gx-detail__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 16px;
}
.gx-detail__row {
  display: flex;
  align-items: baseline;
  gap: 6px;
}
.gx-detail__block {
  font-size: 13px;
}
.gx-detail__label {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  color: #6a6a8a;
  flex-shrink: 0;
  min-width: 72px;
}
.gx-detail__val {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  color: var(--gx-black);
  word-break: break-all;
}
.gx-detail__val--money {
  color: #F04E45;
  font-weight: 700;
}
.gx-detail__val--money-sub {
  margin-left: 4px;
  color: #999;
  font-size: 12px;
  font-weight: normal;
}
.gx-detail__copy {
  cursor: pointer;
  margin-left: 6px;
  color: #6A6A8A;
  font-style: normal;
}

.gx-detail__tag {
  padding: 2px 7px;
  border-radius: 4px;
  font-size: 11px;
  white-space: nowrap;
}
.gx-detail__tag--type {
  background: rgba(255,245,245);
  border: 1px solid rgb(255, 204, 199);
  color: var(--gx-red);
}
.gx-detail__tag--warn {
  background: rgb(255, 247, 230);
  border: 1px solid rgb(255, 213, 145);
  color: var(--gx-orange);
}
.gx-detail__tag--ok {
  background: rgba(74, 222, 128, .1);
  border: 1px solid rgba(74, 222, 128, .3);
  color: #22C55E;
}
.gx-detail__tag--fail {
  background: rgba(240, 78, 69, .1);
  border: 1px solid rgba(240, 78, 69, .35);
  color: #F04E45;
}
.gx-detail__tag--info {
  background: rgba(139, 157, 195, .1);
  border: 1px solid rgba(139, 157, 195, .3);
  color: #6A6A8A;
}
.gx-detail__product {
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
}
.gx-detail__info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 16px;
  margin-top: 12px;
}
.gx-detail__info-label {
  font-size: 10px;
  color: rgb(106, 106, 138);
  flex-shrink: 0;
  min-width: 64px;
}
.gx-detail__info-item {
  font-size: 11px;
  color: rgb(26, 26, 46);
  word-break: break-all;
}
.gx-detail__product--1688{
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 6px;
  background: rgb(230, 244, 255);
  border: 1px solid rgb(145, 202, 255);
}
.gx-detail__price{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  color: rgb(106, 106, 138);
  font-weight: 500;
  margin-bottom: 7px;
  margin-top: 12px;
}
.gx-detail__pic{
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
.gx-detail__pic-img {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
}
.gx-detail__pic-img--1688{
  background: rgb(230, 244, 255);
  border: 1px solid rgb(145, 202, 255);
}
.gx-detail__pic-type{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 9px;
  color: rgb(106, 106, 138);
}
.gx-detail__pimg {
  width: 56px;
  height: 56px;
  border-radius: 8px;
  background: linear-gradient(135deg, #E1E5EE, #FFFFFF);
  border: 1px solid rgba(212, 169, 70, .2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
  overflow: hidden;
}
.gx-detail__pimg img, .gx-detail__pic-img img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}
.gx-detail__pimg .is-empty {
  background: linear-gradient(135deg, #f0f0f0, #e0e0e0);
}

.is-link{
  cursor: pointer;
}
.gx-detail__switch{
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(106, 106, 138);
  font-size: 16px;
  flex-shrink: 0;
}
.gx-detail__pbody {
  flex: 1;
  min-width: 0;
}
.gx-detail__ptitle {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: var(--gx-black);
  font-weight: 500;
  line-height: 1.4;
  margin-bottom: 3px;
  word-break: break-all;
}
.gx-detail__p1688title{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  line-height: 1.4;
  word-break: break-all;
}
.gx-detail__pmeta,
.gx-detail__pspec {
  font-size: 12px;
  color: #6A6A8A;
  margin: 4px 0;
}
.gx-detail__trade-footer {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  padding-top: 12px;
  margin-top: 12px;
  border-top: 1px dashed #EEF1F6;
  font-size: 12px;
  color: #6A6A8A;
}
.gx-detail__gold {
  color: #D4A946;
}
.gx-detail__timeline {
  position: relative;
}
.gx-detail__tl-item {
  position: relative;
  padding: 0 0 16px 24px;
  /*border-left: 1px solid #E1E5EE;*/
  margin-left: 7px;
}
.gx-detail__tl-item::before{
  content: '';
  position: absolute;
  top: 4px;
  left: -1px;
  width: 1px;
  height: 100%;
  background: #E1E5EE;
}
.gx-detail__tl-item:last-child {
  border-left-color: transparent;
}
.gx-detail__tl-item:last-child::before{
  content: none;
}
.gx-detail__tl-body {
  background: #F6F7F9;
  border-radius: 8px;
  padding: 10px 12px;
}
.gx-detail__tl-item--user .gx-detail__tl-body {
  background: #FDECEA;
}
.gx-detail__tl-item--plain .gx-detail__tl-body {
  background: transparent;
  padding: 0;
  border-radius: 0;
}
.gx-detail__tl-item--user .gx-detail__tl-action {
  color: var(--gx-red);
}
.gx-detail__tl-dot {
  position: absolute;
  left: -5px;
  top: 3px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #D4A946;
  box-sizing: border-box;
}
.gx-detail__tl-item--user .gx-detail__tl-dot {
  background: var(--gx-red);
}
.gx-detail__tl-item--ok .gx-detail__tl-dot {
  background: var(--gx-green);
}
.gx-detail__tl-item--done .gx-detail__tl-dot {
  background: #FFFFFF;
  border: 2px solid #C8CCD4;
}
.gx-detail__tl-action {
  font-size: 13px;
  font-weight: 600;
  color: #1A1A2E;
  line-height: 1.45;
}
.gx-detail__tl-time {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  color: #9AA0AE;
  margin-top: 2px;
}
.gx-detail__tl-item--plain .gx-detail__tl-time {
  color: #B6BAC4;
}
.gx-detail__tl-text {
  font-size: 12px;
  color: #4A4A6A;
  margin-top: 3px;
  line-height: 1.6;
}
.gx-detail__tl-kvs {
  margin-top: 6px;
  font-size: 12px;
  color: #6A6A8A;
}
.gx-detail__tl-kvs p {
  margin: 2px 0;
}
.gx-detail__tl-kvs em {
  color: #1A1A2E;
  font-style: normal;
}
.gx-detail__tl-evidence {
  margin-top: 8px;
  padding: 8px;
  background: #FBFBFD;
  border-radius: 8px;
}
.gx-detail__tl-evidence-hd {
  font-size: 11px;
  color: #6A6A8A;
  margin-bottom: 6px;
}
.gx-detail__tl-evidence-desc {
  font-size: 12px;
  color: #4A4A6A;
  margin-bottom: 6px;
}
.gx-detail__tl-evidence-imgs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.gx-detail__tl-evidence-thumb {
  width: 56px;
  height: 56px;
  border-radius: 6px;
  overflow: hidden;
  cursor: zoom-in;
}
.gx-detail__tl-evidence-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-detail__tl-placeholder {
  font-size: 12px;
  color: #909399;
}
.gx-detail__tl-placeholder p {
  margin: 6px 0;
}
.gx-detail__tl-toggle {
  text-align: center;
  margin-top: 8px;
}
.gx-detail__card-tabs {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
}
.gx-detail__tabs {
  display: flex;
  border-bottom: 1px solid #E1E5EE;
  margin-bottom: 12px;
}
.gx-detail__tab {
  padding: 8px 16px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 13px;
  color: #4A4A6A;
  position: relative;
}
.gx-detail__card-tabs .gx-detail__tab {
  padding: 4px 10px;
  font-size: 12px;
  border-radius: 4px;
}
.gx-detail__card-tabs .gx-detail__tab--on {
  background: rgba(240, 78, 69, .08);
}
.gx-detail__card-tabs .gx-detail__tab--on::after {
  content: none;
}
.gx-detail__tab--on {
  color:var(--gx-red);
  font-weight: 600;
}
.gx-detail__tab--on::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #F04E45, #F58A84);
}
.gx-detail__log-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.gx-detail__modal {
  position: fixed;
  inset: 0;
  z-index: 700;
  background: rgba(0, 0, 0, .48);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.gx-detail__modal-box {
  width: 100%;
  max-width: 480px;
  border-radius: 12px;
  background: #FFFFFF;
  border: 1px solid #EBEEF5;
  box-shadow: 0 20px 56px rgba(15, 23, 42, .14);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}
.gx-detail__modal-box--lg {
  max-width: 680px;
}
.gx-detail__modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  border-bottom: 1px solid #E1E5EE;
  flex-shrink: 0;
  background: #FFFFFF;
}
.gx-detail__modal-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 15px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-detail__modal-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #6A6A8A;
  font-size: 14px;
}
.gx-detail__modal-body {
  padding: 18px 20px;
  overflow-y: auto;
}
.gx-detail__modal-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid #E1E5EE;
  flex-shrink: 0;
  align-items: center;
  background: #FFFFFF;
}
.gx-detail__field {
  margin-bottom: 14px;
}
.gx-detail__input {
  width: 100%;
  height: 34px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid #E4E7ED;
  background: #FAFBFC;
  font-size: 13px;
  color: #1A1A2E;
  outline: none;
  box-sizing: border-box;
  transition: border-color .15s ease, box-shadow .15s ease, background .15s ease;
}
.gx-detail__input:focus {
  border-color: #F04E45;
  background: #FFFFFF;
  box-shadow: 0 0 0 2px rgba(240, 78, 69, .08);
}
.gx-detail__textarea {
  width: 100%;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #E4E7ED;
  background: #FAFBFC;
  font-size: 13px;
  color: #1A1A2E;
  outline: none;
  box-sizing: border-box;
  resize: vertical;
  font-family: inherit;
  transition: border-color .15s ease, box-shadow .15s ease, background .15s ease;
}
.gx-detail__textarea:focus {
  border-color: #F04E45;
  background: #FFFFFF;
  box-shadow: 0 0 0 2px rgba(240, 78, 69, .08);
}
.gx-detail__select {
  width: 100%;
  height: 34px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid #E4E7ED;
  background: #FAFBFC;
  font-size: 13px;
  color: #1A1A2E;
  outline: none;
  transition: border-color .15s ease, box-shadow .15s ease, background .15s ease;
}
.gx-detail__select:focus {
  border-color: #F04E45;
  background: #FFFFFF;
  box-shadow: 0 0 0 2px rgba(240, 78, 69, .08);
}
.gx-detail__note {
  font-size: 11px;
  color: #6A6A8A;
  margin-top: 4px;
}
.gx-detail__upload {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
}
.gx-detail__upload-img {
  width: 64px;
  height: 64px;
  border-radius: 6px;
  object-fit: cover;
  border: 1px solid #E1E5EE;
}
.gx-detail__preview-img {
  width: 100%;
  border-radius: 8px;
}

.gx-detail__ops {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #ECEEF3;
}
.gx-detail__ops-hd {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}
.gx-detail__ops-empty-tip {
  font-size: 12px;
  color: #999;
  line-height: 1.6;
  margin: 0;
}
.gx-detail__ww {
  margin-left: 6px;
  cursor: pointer;
  color: #1966ff;
  font-size: 16px;
  vertical-align: middle;
}
</style>
